import classNames from "classnames";

import { PropsWithClassName } from 'shared/props';
import { ContentPanel, ContentPanelInteraction, EtfLabel, LinkButton } from 'shared/ui-kit';

import styles from "./comparison.module.scss";

import { createHelpHref } from '../utils';

export interface EtfFactorAnalysisComparisonProps {
	ticker: string;
}
export const EtfFactorAnalysisComparison = (props: EtfFactorAnalysisComparisonProps & PropsWithClassName) => {
	return (
		<div className={classNames("flex-container-horizontal", "flex-container-horizontal-break-1000", props.className, styles.container)}>
			<Item ticker={props.ticker} icon="fas fa-piggy-bank" anchor="inflation" compareText="Инфляция" compareTicker="Inflation&rf=0." compareDescription={`Отчет сравнения доходности фонда ${props.ticker} с индексом потребительских цен на товары и услуги по версии Федеральной службы государственной статистики`} />
			<Item ticker={props.ticker} icon="fas fa-coins" anchor="revenue" compareText="Вклад" compareTicker="Deposit&rf=0." compareDescription={`Отчет сравнения доходности фонда ${props.ticker} с вкладами по максимальной ставке в топ-10 банков по версии Центрального Банка Российской Федерации`} />
		</div>
	)
}

interface ItemProps {
	ticker: string;
	anchor: string;
	icon: string;
	compareText: string;
	compareTicker: string;
	compareDescription: string;
}
const Item = (props: ItemProps) => {
	return (
		<ContentPanel anchor={props.anchor} title={<EtfLabel ticker={props.ticker} suffix={`и ${props.compareText}`} />} className={classNames("flex-size-fill", styles.item)} help={{ href: createHelpHref("comparison") }}>
			<ContentPanelInteraction className={styles.interaction}>
				<p>
					<LinkButton
						title="СРАВНИТЬ ГРАФИКИ"
						href={`/etf/report/${props.ticker}?options=vs=${props.compareTicker}`}
						className={styles.button}
						rel="nofollow"
						target="_blank"
						iconClass={props.icon} /> vs {props.compareText}
				</p>
			</ContentPanelInteraction>
			<p className={styles.compareText}>
				{props.compareDescription}
			</p>
		</ContentPanel>
	)
}